// extracted by mini-css-extract-plugin
module.exports = {"container":"AtEventScheduleMovies_container__2IRFI","time":"AtEventScheduleMovies_time__qeo9f","at_movies_area":"AtEventScheduleMovies_at_movies_area__2rkv3"};